<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :delete_url="delete_url"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/omsRuleQueueEventLogs.module";

export default {
  name: "OMSRuleQueueEventLogs",
  components: { DataTable },
  data: () => ({
    delete_url: `${process.env.VUE_APP_BASE_URL}/order_management/brands/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getOMSRULEQUEQUEEVENTLOGSTableFilters",
      getTableState: "getOMSRULEQUEQUEEVENTLOGSTableState",
      getTableData: "getOMSRULEQUEQUEEVENTLOGSTableData",
      getTableHeaders: "getOMSRULEQUEQUEEVENTLOGSTableHeaders",
      getTableProperties: "getOMSRULEQUEQUEEVENTLOGSTableProperties",
      getTableExportUrl: "getOMSRULEQUEQUEEVENTLOGSExportUrl",
      getTablePermissions: "getOMSRULEQUEQUEEVENTLOGSTablePermissions",
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return !!this.$store.getters[this.store_names.getTableData];
    },
  },
  mounted() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
